import {
  ButtonSecondary,
  ButtonSize,
  IconExpand,
  IconLoader,
  Select,
  SelectSize,
} from '@ui/src';
import { v4 as uuid } from 'uuid';
import { Controller } from 'react-hook-form';
import StepPartBlock from '../../corporate/parts/step-part-block';
import { AffilatedCompaniesTypes } from './types';
import InfoRow from '../../info-row';
import {
  AffilatedCompanyFormValues,
  NewApplicationStatus,
} from '../../../../hoc/new-application/types';
import AffilatedCompany from './affilated-company';

import cn from '../../new-application.module.css';

const AffilatedCompanies = ({
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  status,
  isEditable,
  questionnarieFields,
  affilatedCompaniesValues,
  setAffilatedCompaniesValues,
  affilatedCompaniesIsLoading,
  affilatedCompaniesIsFetching,
  deleteAffilatedCompanyInProgress,
  onDeleteAffilatedCompany,
  selectedAffilatedCompanyId,
  uboPercentage,
  countries,
}: AffilatedCompaniesTypes) => (
  <StepPartBlock title="Information about affiliated companies" zIndex={27}>
    <InfoRow
      title={`Are you the director / controlling person / shareholder – beneficial owner of more than ${uboPercentage}% of ownership of a company?`}
      id="hasAffiliatedCompanies"
      style={{
        position: 'relative',
        zIndex: 17,
      }}
      lessPadding
    >
      <Controller
        control={questionnarieControl}
        name="hasAffiliatedCompanies"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <Select
            name={name}
            placeholder="Select an option..."
            list={[
              {
                name: 'Yes',
                value: 'yes',
              },
              {
                name: 'No',
                value: 'no',
              },
            ]}
            value={value as string}
            size={SelectSize.SMALL}
            onChange={(e) => {
              onChange(e);
              questionnarieClearErrors(['hasAffiliatedCompanies']);
            }}
            selectWrapperClassName={
              status === NewApplicationStatus.ACCEPTED ||
              status === NewApplicationStatus.DECLINED
                ? cn.selectDisabled
                : ''
            }
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            error={questionnarieErrors?.belongsToGroup?.message}
            fullWidth
            borderless
          />
        )}
      />
    </InfoRow>
    {questionnarieFields?.hasAffiliatedCompanies === 'yes' && (
      <div className={cn.accountsCurrenciesList}>
        {questionnarieErrors?.questionnairesAffiliatedCompanies?.message && (
          <div className={cn.questionnarieError}>
            {questionnarieErrors?.questionnairesAffiliatedCompanies?.message}
          </div>
        )}
        {!affilatedCompaniesIsLoading && !affilatedCompaniesIsFetching && (
          <>
            {affilatedCompaniesValues?.map((item, index) => (
              <AffilatedCompany
                key={item.id}
                status={status}
                isEditable={isEditable}
                affilatedCompaniesValues={affilatedCompaniesValues}
                setAffilatedCompaniesValues={setAffilatedCompaniesValues}
                deleteAffilatedCompanyInProgress={
                  deleteAffilatedCompanyInProgress
                }
                onDeleteAffilatedCompany={onDeleteAffilatedCompany}
                selectedAffilatedCompanyId={selectedAffilatedCompanyId}
                countries={countries}
                index={index}
                affilatedCompany={item}
              />
            ))}
            {status !== NewApplicationStatus.ACCEPTED &&
              status !== NewApplicationStatus.DECLINED && (
                <ButtonSecondary
                  text="Add company"
                  icon={<IconExpand />}
                  className={`button-white ${cn.addAccountCurrencyButton}`}
                  size={ButtonSize.SMALL}
                  onClick={() => {
                    let nextAffilatedCompanies: AffilatedCompanyFormValues[] =
                      [];

                    if (affilatedCompaniesValues) {
                      nextAffilatedCompanies = (
                        [] as AffilatedCompanyFormValues[]
                      ).concat(affilatedCompaniesValues);
                    }

                    nextAffilatedCompanies.push({
                      id: `affilated-company-${uuid()}`,
                      name: '',
                      registrationNumber: '',
                      mainActivities: '',
                      position: '',
                      countryId: '',
                      percentageOfOwnership: '',
                    });

                    setAffilatedCompaniesValues(nextAffilatedCompanies);
                  }}
                />
              )}
          </>
        )}
        {(affilatedCompaniesIsLoading || affilatedCompaniesIsFetching) && (
          <div className={cn.accountsCurrenciesLoader}>
            <IconLoader />
          </div>
        )}
      </div>
    )}
  </StepPartBlock>
);

export default AffilatedCompanies;
